import React from 'react';
import MockupPreviewPage from './MockupPreviewPage';

const MockupsPage = () => (
    <MockupPreviewPage
        title="Mockups preview"
        subtitle="Generated mockups per upload; group by customer to see a customer’s uploads together."
        allowGrouping
    />
);

export default MockupsPage;
